import { Component, OnInit } from '@angular/core';
import { AudioService } from 'src/app/services/audio/audio.service';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})

export class OverlayComponent implements OnInit {

  constructor( private audioService: AudioService) {
   
   }

  ngOnInit() {
    this.audioService.stopMusic();

    this.audioService.playSound("WelcomeSplash");

    setTimeout(() => {
      this.audioService.playMusic("BGMusic");
    }, 5000);
  }
}
